import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';

class SeminarBMZ1 extends Component {
  state = {
    registered: {}
  };

  componentDidMount() {
    // Load saved registration data from localStorage
    const saved = localStorage.getItem("registered_bmz");
    if (saved) {
      this.setState({ registered: JSON.parse(saved) });
    }
  }

  handleRegister = (id) => {
    const isRegistered = this.state.registered[id];

    if (isRegistered) {
      // Ask to unregister with PIN
      const pin = window.prompt("Enter PIN to unregister:");
      if (pin === "2323") {
        this.setState((prevState) => {
          const updated = { ...prevState.registered };
          delete updated[id];
          localStorage.setItem("registered_bmz", JSON.stringify(updated));
          return { registered: updated };
        });
        alert("Unregistered successfully.");
      } else if (pin !== null) {
        alert("Incorrect PIN. Unregister cancelled.");
      }
    } else {
      // Ask to register
      const confirmRegister = window.confirm("Do you want to register?");
      if (confirmRegister) {
        this.setState((prevState) => {
          const updated = { ...prevState.registered, [id]: true };
          localStorage.setItem("registered_bmz", JSON.stringify(updated));
          return { registered: updated };
        });
      }
    }
  };

  renderParticipant = (id, name) => {
    const isRegistered = this.state.registered[id];
    return (
      <div key={id}>
        <span
          onClick={() => this.handleRegister(id)}
          style={{
            color: isRegistered ? "red" : "blue",
            cursor: "pointer"
          }}
        >
          {id}. {name}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className='AllClasses'>
        <h3>BMZ Participants Day 1</h3>
        <br /><br />

        {this.renderParticipant(1, "Mr.Shintaro Kon")}
        <br />
        {this.renderParticipant(2, "Mr.Kenichi Ishioka")}
        <br />
        {this.renderParticipant(3, "Mr.Shoson Thatawakorn")}
        <br />
        {this.renderParticipant(4, "Mr.Nirat Boonyasawet")}
        <br />

        <div>
          ASEAN AIKIDO FELLOWSHIP SEMINAR 2025 REGISTRATION SYSTEM...
        </div>
        <br /><br />
        <div>Powered by</div>
        <img className='logo2' src={logo2} alt="logo" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default SeminarBMZ1;
